import { Component, input, signal } from '@angular/core';
import { NgStyle } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TabBarComponent } from '../tab-bar';

const getAnimations = () => {
  return trigger('moveMarker', [
    state('-3', style({ left: '-300%' })),
    state('-2', style({ left: '-200%' })),
    state('-1', style({ left: '-100%' })),
    state('0', style({ left: '0%' })),
    state('1', style({ left: '100%' })),
    state('2', style({ left: '200%' })),
    state('3', style({ left: '300%' })),
    transition('* => *', [animate('0.25s cubic-bezier(0.35, 0, 0.25, 1)')]),
  ]);
};

@Component({
  selector: 'app-tab-bar-item',
  imports: [NgStyle],
  templateUrl: './tab-bar-item.html',
  styleUrls: ['./tab-bar-item.scss'],
  animations: [getAnimations()],
})
export class TabBarItemComponent {
  fa_icon = signal<string>('');
  svg_icon = input<string>('');
  inactive = input<boolean>(false);

  preIsActive = signal<boolean>(true);
  isActive = signal<boolean>(false);
  inMovement = signal<boolean>(false);
  moveMarker = signal<string>('0');
  opaque = signal<boolean>(false);
  icon = signal<boolean>(false);
  disabled = signal<boolean>(false);

  // Reference to parent tab bar
  tabBarReference: TabBarComponent | null = null;
  index = signal<number>(-1);

  readonly isChrome = true;

  onClick() {
    if (this.disabled()) return;
    if (!this.inMovement()) {
      this.tabBarReference?.onTabSelect(this.index());
    }
  }
}
